import { Helmet } from 'react-helmet-async'
import PropTypes from 'prop-types'

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  image,
  type = "website",
  noindex = false
}) => {
  const siteUrl = "https://praetorian.works"
  const defaultImage = `${siteUrl}/images/logo/Logo-Praetorian_Works-Square.png`
  const fullTitle = title ? `${title} | Praetorian Works` : "Praetorian Works - Elite Technology Services for HNW/UHNW Clientele"
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl
  const fullImage = image ? `${siteUrl}${image}` : defaultImage

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullCanonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Praetorian Works" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonical} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImage} />
      
      {/* Additional structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "name": "Praetorian Works",
          "url": siteUrl,
          "logo": defaultImage,
          "description": "Elite technology services for High Net Worth and Ultra High Net Worth individuals. White glove support, enterprise security, and technology concierge services.",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+1-408-634-9679",
            "contactType": "Customer Service",
            "availableLanguage": ["English"],
            "areaServed": "Worldwide"
          },
          "areaServed": {
            "@type": "Place",
            "name": "Worldwide"
          }
        })}
      </script>
    </Helmet>
  )
}

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  keywords: PropTypes.string,
  canonical: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.string,
  noindex: PropTypes.bool
}

export default SEO